export default "__VITE_ASSET__Da12KdU9__"